export default __webpack_public_path__ + "media/images/icon_person_add-494e3961d2435c87632ddf74eb1c6461.svg";